// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3y1bp","Primary":"Button_Primary__3OD9b","Text":"Button_Text__2WTXP"};